// Bundle theme module
import NSTheme from './NSTheme';
import Jump from './Classes/Jump'
import NavDropdown from './Classes/NavDropdown'
import Sticky from '../../node_modules/sticky-js';
import Helper from './Classes/Helper';
import TeaserHandler from './Classes/TeaserHandler';
import SearchHandler from './Classes/SearchHandler';
import ShareHandler from './Classes/ShareHandler';
import HeaderStateHandler from './Classes/HeaderStateHandler';
import FocusHandler from './Classes/FocusHandler';
import Accordion from './Classes/Accordion';
import Accessibility from './Classes/Accessibility';
import Lightbox from './Classes/Lightbox';
import LazyLoad from './Classes/Lazyload';
import AltText from './Classes/AltText'
import Gallery from './Classes/Gallery';
import Insights from './Classes/Insights';
import setBackgroundImage from './Classes/setBackgroundImage';
import responsiveTable from './Classes/responsiveTable';
import MoveElementResponsively from './Classes/MoveElementResponsively';
import Totop from './Classes/Totop';
import Video from './Classes/Video';
import LinkTargetHandler from './Classes/LinkTargetHandler';


module.exports = NSTheme;

(function () {
  document.addEventListener('DOMContentLoaded', () => {

    document.querySelector('.nhsnote-box').addEventListener('click', e => {
      Helper.removeClass(document.querySelector('body'), 'lightbox-open');
    });

    Array.prototype.slice.call(document.querySelectorAll('.note')).forEach(note => {
      note.addEventListener('click', e => {
        Helper.addClass(document.querySelector('body'), 'lightbox-open');
        window.dispatchEvent(new Event('resize'));
      });
    });

    new LazyLoad();
    new NavDropdown();
    new SearchHandler();
    new HeaderStateHandler();
    new ShareHandler();
    new Accessibility();
    new FocusHandler();
    new LinkTargetHandler({
      linkSelector: '.js-target-blank a'
    });
    new Jump({
      graphicSelector: '.ns-graphic'
    });
    new Accordion({
      accordions: '.ns-accordion__title'
    });

    if (Helper.isDesktop()) {
      new Sticky('.header__bottom');
    }
    new Insights();

    new Lightbox({
      toggleSelector: '.ns-img--lightbox',
      isImageLightbox: true
    });

    new MoveElementResponsively({
      movableElementSelector: '.ns-content-container__col--left .ns-box-with-image',
      targetContainerSelector: '.ns-content-container__col--right',
      breakpoint: window.matchMedia('(min-width: 768px)'),
    });

    new Gallery();

    new Video();

    new responsiveTable({
      tableSelector: '.ns-table-wrap table',
      tableWrapperSelector: '.ns-table-wrap',
      breakPointLg: 1200,
      breakPointMd: 769,
      breakPointSm: 480,
      colCountNoSplit: 3,
      colCountEarlyBreak: 6,
      noSplitArray: []
    });

    // new setBackgroundImage({
    //   imageContainerSelector: '.ns-img--has-image .ns-quote__img-wrapper'
    // });

    // new Jump({
    //   graphicSelector: '.ns-graphic'
    // });

    new AltText({
      altTextSelector: '.js-alt-text',
    })

    new TeaserHandler( {
      header: '.header',
      teaserContainer: '.teaser',
      teaserLink: '.teaser__link',
      ratioMin: 0.6,
      ratioMax: 2
    });

    new Totop({
      buttonSelector: '.js-totop'
    });
  })
})();
